exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/* Shadows are intentionally very subtle gradiations. */\n.Hero-Hero_3j6xo {\n  text-align: center;\n  padding: 2rem; }\n  @media (min-width: 40em) {\n    .Hero-Hero_3j6xo {\n      padding: 2rem; } }\n", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Hero/Hero.scss"],"names":[],"mappings":"AAAA,wDAAwD;AACxD;EACE,mBAAmB;EACnB,cAAc,EAAE;EAChB;IACE;MACE,cAAc,EAAE,EAAE","file":"Hero.scss","sourcesContent":["/* Shadows are intentionally very subtle gradiations. */\n.Hero {\n  text-align: center;\n  padding: 2rem; }\n  @media (min-width: 40em) {\n    .Hero {\n      padding: 2rem; } }\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"Hero": "Hero-Hero_3j6xo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":true,"importLoaders":1,"localIdentName":"[name]-[local]_[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss"}!./node_modules/sass-loader/lib/loader.js!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["./src/assets/scss/base.scss","./src/assets/scss/helpers.scss"]}!./src/components/Hero/Hero.scss
// module id = 1342
// module chunks = 0